import { z } from 'zod';
export const NotificationChannelSchema = z.enum(['email', 'push', 'sms', 'in_app']);
export const NotificationStatusSchema = z.enum(['pending', 'sent', 'failed', 'read']);
export const NotificationSchema = z.object({
    id: z.string().uuid(),
    userId: z.string().uuid(),
    channel: NotificationChannelSchema,
    type: z.string(),
    title: z.string(),
    body: z.string(),
    data: z.record(z.string(), z.unknown()).optional(),
    status: NotificationStatusSchema,
    readAt: z.string().datetime().nullable().optional(),
    createdAt: z.string().datetime(),
});
export const SendNotificationSchema = z.object({
    userId: z.string().uuid(),
    channel: NotificationChannelSchema,
    type: z.string(),
    title: z.string(),
    body: z.string(),
    data: z.record(z.string(), z.unknown()).optional(),
});
export const NotificationPreferencesSchema = z.object({
    email: z.boolean().default(true),
    push: z.boolean().default(true),
    sms: z.boolean().default(false),
    in_app: z.boolean().default(true),
});
//# sourceMappingURL=notification.js.map